const Pokeball = () => {
  return (
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/5/53/Poké_Ball_icon.svg"
      alt="pokeball"
      height="87"
      width="100"
    />
  )
}

export default Pokeball;